<template>
  <span
    v-if="helpDescription"
    v-b-tooltip.hover.top="{ variant: 'info' }"
    :title="helpDescription"
  >
    <base-icon icon="question-circle" class="text-info" />
  </span>
</template>

<script>
import { BaseIcon } from "./";

/**
##Icons dependencies
Add this font awesome icons to your target project

```js
import {
  faQuestionCircle,
} from '@fortawesome/pro-light-svg-icons';

library.add(
  faQuestionCircle,
);
```
 */
export default {
  components: { BaseIcon },
  props: {
    helpDescription: {
      type: String,
      default: null,
    },
  },
};
</script>